// import { CardProps } from "../components/Card/Card";
import Card from "../components/Card/Card";

import styles from "../components/Card/Card.module.css";

import { useDispatch } from "react-redux";
import { deleteListingThunk } from "../store/listing/deleteListingThunk";
import { AppDispatch } from "../store";
import { toast } from "react-toastify";

import { useNavigate } from "react-router";


export interface CardMapValue {
  images: {
    values: { stringValue: string }[];
  };
  beds: string;
  baths: string;
  address: string;
  price: string;
  description: string;
  createdAt: string;
  sellRent: string;
  id: string;
}

interface CardLayoutProps {
  cardItems: CardMapValue[];
}

export default function CardLayout(cardItems: CardLayoutProps) {
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();

  async function onDeleteSpecificCard(id: string) {
    try {
      const resultAction = await dispatch(deleteListingThunk({ id }));

      if (deleteListingThunk.rejected.match(resultAction)) {
        toast.error(resultAction?.payload?.message);
      } else {
        toast.success("Listing deleted successfully");
      }
    } catch (error) {
      toast.error("Failed to delete listing");
    }
  }

  function onEditSpecificCard(id: string) {
    navigate(`/edit-listing/${id}`);
  }

  return (
    <div className="container">
      <section className={styles.cardLayout}>
        <ul>
          {cardItems.cardItems.map((cardItem, index) => (
            <li key={index}>
              <Card
                item={cardItem}
                edit={true}
                onDelete={(id) => onDeleteSpecificCard(id)}
                onEdit={onEditSpecificCard}
                index={index}
              />
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
